import { getRootElement } from '@active/react-ui/config'

const modalESC = e => {
  if (e.which === 27) {
    const modalList = getRootElement().getElementsByClassName('passport-ui-app__modal')
    let openModal = null
    for (let i = 0; i < modalList.length; i++) {
      if (modalList[i].classList.contains('is-open')) {
        openModal = modalList[i]
        break
      }
    }
    const modalClose = openModal && openModal.firstChild.firstChild.children[1]
    modalClose && modalClose.click()
  }
}

export const addEvents = () => {
  window.addEventListener('invalid', event => {
    event.preventDefault()
  }, true)

  window.addEventListener('keydown', modalESC, true)
}

export const removeEvents = () => {
  window.removeEventListener('invalid', event => {
    event.preventDefault()
  }, true)
  window.removeEventListener('keydown', modalESC, true)
}
